// Resolves the phone/email shown in the property-detail "Quick Contact" banner.
// Precedence: assigned team member -> org primary contact (only when opted in
// for the property page) -> org inbound number / org email. Returns undefined
// when nothing usable is configured, so the caller can omit the link instead of
// rendering `tel:undefined` / `mailto:undefined`.

interface TeamMemberContact {
  phone_number?: string | null;
  email?: string | null;
}

interface OrgContactConfig {
  orgData?: {
    primary_contact?: {
      useForPropertyPage?: boolean;
      phone?: string | null;
      email?: string | null;
    } | null;
    phoneNumbers?: { inbound?: string | null } | null;
    email?: string | null;
  } | null;
}

const firstNonEmpty = (
  ...values: Array<string | null | undefined>
): string | undefined => {
  for (const value of values) {
    const trimmed = (value ?? "").trim();
    if (trimmed) return trimmed;
  }
  return undefined;
};

export const resolvePropertyContactPhone = (
  config?: OrgContactConfig,
  teamMember?: TeamMemberContact,
): string | undefined =>
  firstNonEmpty(
    teamMember?.phone_number,
    config?.orgData?.primary_contact?.useForPropertyPage
      ? config?.orgData?.primary_contact?.phone
      : undefined,
    config?.orgData?.phoneNumbers?.inbound,
  );

export const resolvePropertyContactEmail = (
  config?: OrgContactConfig,
  teamMember?: TeamMemberContact,
): string | undefined =>
  firstNonEmpty(
    teamMember?.email,
    config?.orgData?.primary_contact?.useForPropertyPage
      ? config?.orgData?.primary_contact?.email
      : undefined,
    config?.orgData?.email,
  );
